import React, { useState } from 'react';
import '../components/DBOSHomepage.css';
import SiteHeader from '../components/SiteHeader';
import './SmartWeb.css';

const team = [
  { name: 'Ray', title: 'Founder & Architect', quote: 'Work beats Design.', img: 'ray-michael.jpg', linkedin: 'https://www.linkedin.com/in/raymichaelbridge/' },
  { name: 'Niklas', title: 'Migration & Systems - Germany', quote: 'Performance is love.', img: 'niklas-rempel.jpg', linkedin: 'https://www.linkedin.com/in/niklas-rempel-3443b4426/' },
  { name: 'Jakub', title: 'Security & Identity Architecture', quote: "Right is staying within approved boundaries. Truth can't be gathered by being right.", img: 'jakub-mikolajek.jpg', linkedin: 'https://www.linkedin.com/in/jakub-mikolajek-77aba21b0/' },
  { name: 'Thomas', title: 'Legacy Systems & Migration - Ireland', quote: 'Audit first. Never deploy on a guess.', img: 'thomas-jourdan.jpg', linkedin: 'https://www.linkedin.com/in/thomas-jourdan-delphicoder/' },
  { name: 'Rachael', title: 'Onboarding & Success', quote: 'Confidence is tested by consequence.', img: 'rachael-fish.jpg', linkedin: 'https://www.linkedin.com/in/rachael-fish-bb7008189/' },
];

const OurStory = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [formStatus, setFormStatus] = useState(null);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('sending');
    try {
      const res = await fetch('https://europe-west1-dbos-core-prod.cloudfunctions.net/sendRequestForm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, solution: 'General Inquiry', country: 'IE' }),
      });
      setFormStatus(res.ok ? 'success' : 'error');
    } catch (err) {
      setFormStatus('error');
    }
  };
  return (
    <div className="solution-page">
      <SiteHeader active="our-story" />

      <main className="solution-content">
        <div className="container">
          <img src="/assets/img/our-story-background-header.jpg" alt="DBOS" className="ourstory-banner" />

          <section className="hero-section">
            <h1 className="page-title">Our Story</h1>
            <p className="page-subtitle">Building the future of digital trust from Ireland</p>
          </section>

          <section className="content-section">
            <h2>Vision & Mission</h2>
            <p><strong>Our Vision:</strong> "To become the global gold standard of digital trust and operating infrastructure for regulated small and medium enterprises."</p>
            <p><strong>Our Mission:</strong> "We empower business owners with total data sovereignty and real-time operational clarity - delivering enterprise-grade infrastructure, reliable workflows, and safe, human-guided AI that puts control back where it belongs."</p>
          </section>

          <section className="content-section">
            <h2>Why DBOS Exists</h2>
            <p>Most SME owners are paying for 20+ fragmented software tools, drowning in disconnected data, and worried about falling behind in the AI race - all while trying to keep on top of strict European privacy laws.</p>
            <p>We built DBOS: a single, unified Digital Business Operating System designed specifically for local SMEs. It gives you enterprise-grade AI, automates core processes, and keeps your data under your control.</p>
            <p><strong>Our Core Principle:</strong> "AI describes, the operator decides." We use compliant AI to deliver real operational insight, while strategic control stays firmly in human hands.</p>
          </section>

          <section className="content-section">
            <h2>Founder & Architecture Leadership</h2>
            <p>DBOS was founded by <strong>Ray</strong>, bringing over 25 years of experience in enterprise IT architecture, high-transactional platforms, and ITIL service management - working with organisations including Dell (Germany), BMC Software (US), Synaxon (UK), and Lufthansa (Germany).</p>
            <p>As an accredited instructor for Scrum.org and the DevOps Institute, Ray has trained Scrum Masters and IT leaders in servant leadership - a mindset that directly shapes how DBOS serves its SME clients today.</p>
          </section>

          <section className="content-section">
            <h2>Meet the Team</h2>
            <div className="team-grid">
              {team.map((person) => (
                <div key={person.name} className="team-card">
                  <img src={`/assets/img/${person.img}`} alt={person.name} className="team-photo" />
                  <h3>{person.name}</h3>
                  <p className="team-title">{person.title}</p>
                  <p className="team-quote">"{person.quote}"</p>
                  <a href={person.linkedin} target="_blank" rel="noopener noreferrer" className="team-linkedin">LinkedIn</a>
                </div>
              ))}
            </div>
          </section>

          <section className="content-section">
            <h2>Where We're Based</h2>
            <p>Founded in Cavan, Ireland. We run live infrastructure across two European data centres and in the United States, serve clients in Ireland, Germany, and the United Kingdom, and are expanding to Cyprus - our future European R&D hub.</p>
          </section>

          <section className="cta-section">
            <h2>Ready to Simplify Your Business Operations?</h2>
            <p className="cta-lead">Have a question about migration, compliance, or architecture? We're happy to talk.</p>
            {formStatus === 'success' ? (
              <p className="tile-form-success">Thanks - we'll be in touch shortly.</p>
            ) : (
              <form className="tile-form" onSubmit={handleFormSubmit} style={{ maxWidth: '480px', margin: '20px auto 0' }}>
                <input
                  type="text"
                  placeholder="Your Name"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="tile-form-input"
                />
                <input
                  type="email"
                  placeholder="your@email.com"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="tile-form-input"
                />
                <input
                  type="tel"
                  pattern="[0-9+\-\s()]*"
                  inputMode="tel"
                  title="Numbers, spaces, +, -, and () only"
                  placeholder="Phone (optional)"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value.replace(/[^0-9+\-\s()]/g, '') })}
                  className="tile-form-input"
                />
                <textarea
                  placeholder="Your message (optional, max 500 characters)"
                  maxLength={500}
                  rows={4}
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="tile-form-input"
                />
                <div className="char-count">{formData.message.length} / 500</div>
                <button type="submit" className="btn-primary" disabled={formStatus === 'sending'}>
                  {formStatus === 'sending' ? 'Sending...' : 'Send Message'}
                </button>
                {formStatus === 'error' && (
                  <p className="tile-form-error">Something went wrong - please try again or email hello@dbos.world.</p>
                )}
              </form>
            )}
          </section>        </div>
      </main>

      <footer className="footer">
        <div className="container footer-compact">
          <div className="footer-row-2">
            <span className="copyright">© 2026 DBOS. Ireland (CRO Registered). All rights reserved.</span>
            <span className="footer-divider">|</span>
            <a href="/legal/terms">Terms</a>
            <a href="/legal/privacy">Privacy</a>
            <a href="/legal/cookies">Cookies</a>
            <a href="/legal/dpa">DPA</a>
            <span className="footer-divider">|</span>
            <a href="mailto:hello@dbos.world">hello@dbos.world</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default OurStory;
